export const PROTOCOL_VERSION = 1;
export const PAYLOAD_VERSION = 1;
export const KEY_DERIVATION_HINT = "xchacha20poly1305-hkdf-aeskw-v1";
export const SYNC_KDF_INFO = "trustii-wallet-sync-v1";
export const WRAP_KDF_INFO = "trustii-wallet-sync-wrap-v1";
export const ENROLLMENT_TTL_SECONDS = 5 * 60;
export const ENROLLMENT_DEEP_LINK_SCHEME = "trustii://enroll";
